import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth } from "@/auth/RequireAuth";
import { AccountPage } from "@/pages/AccountPage";
import { BrandAssetsPage } from "@/pages/BrandAssetsPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { InvoiceDetailPage } from "@/pages/InvoiceDetailPage";
import { InvoicesListPage } from "@/pages/InvoicesListPage";
import { LoginPage } from "@/pages/LoginPage";
import { MessagesPage } from "@/pages/MessagesPage";
import { NewProjectRequestPage } from "@/pages/NewProjectRequestPage";
import { OrderDetailPage } from "@/pages/OrderDetailPage";
import { OrdersListPage } from "@/pages/OrdersListPage";
import { QuotesPage } from "@/pages/QuotesPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";
import { SignupPage } from "@/pages/SignupPage";
import { StoreJoinPage } from "@/pages/StoreJoinPage";
import { StoreApprovalsPage } from "@/pages/StoreApprovalsPage";
import { StoreCartPage } from "@/pages/StoreCartPage";
import { StoreOrdersPage } from "@/pages/StoreOrdersPage";
import { StorePage } from "@/pages/StorePage";
import { StoreProductPage } from "@/pages/StoreProductPage";
import { StorePeoplePage } from "@/pages/StorePeoplePage";
import { StoreSettingsPage } from "@/pages/StoreSettingsPage";
import { StoreSignoffPage } from "@/pages/StoreSignoffPage";
import { VerifyEmailPage } from "@/pages/VerifyEmailPage";

export function App() {
  return (
    <Routes>
      {/* Public auth pages */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Company stores — public (the link is the gate) */}
      <Route path="/store-signoff/:token" element={<StoreSignoffPage />} />
      <Route path="/join/:slug" element={<StoreJoinPage />} />
      {/* Same token + endpoint as reset-password; store welcome words. */}
      <Route path="/store-invite" element={<ResetPasswordPage mode="store" />} />

      {/* Company stores — signed in. `store` lets a store employee in; every
          other page sends them to /store. Admin pages check the role. */}
      <Route path="/store" element={<RequireAuth store><StorePage /></RequireAuth>} />
      <Route path="/store/product/:id" element={<RequireAuth store><StoreProductPage /></RequireAuth>} />
      <Route path="/store/cart" element={<RequireAuth store><StoreCartPage /></RequireAuth>} />
      <Route path="/store/orders" element={<RequireAuth store><StoreOrdersPage /></RequireAuth>} />
      <Route path="/store/admin/people" element={<RequireAuth store><StorePeoplePage /></RequireAuth>} />
      <Route path="/store/admin/approvals" element={<RequireAuth store><StoreApprovalsPage /></RequireAuth>} />
      <Route path="/store/admin/settings" element={<RequireAuth store><StoreSettingsPage /></RequireAuth>} />

      {/* Authenticated portal */}
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <DashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/orders"
        element={
          <RequireAuth>
            <OrdersListPage />
          </RequireAuth>
        }
      />
      <Route
        path="/orders/:id"
        element={
          <RequireAuth>
            <OrderDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="/quotes"
        element={
          <RequireAuth>
            <QuotesPage />
          </RequireAuth>
        }
      />
      <Route
        path="/invoices"
        element={
          <RequireAuth>
            <InvoicesListPage />
          </RequireAuth>
        }
      />
      <Route
        path="/invoices/:id"
        element={
          <RequireAuth>
            <InvoiceDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="/brand-assets"
        element={
          <RequireAuth>
            <BrandAssetsPage />
          </RequireAuth>
        }
      />
      <Route
        path="/request-project"
        element={
          <RequireAuth>
            <NewProjectRequestPage />
          </RequireAuth>
        }
      />
      <Route
        path="/account"
        element={
          <RequireAuth>
            <AccountPage />
          </RequireAuth>
        }
      />
      <Route
        path="/messages"
        element={
          <RequireAuth>
            <MessagesPage />
          </RequireAuth>
        }
      />
      <Route
        path="/messages/:id"
        element={
          <RequireAuth>
            <MessagesPage />
          </RequireAuth>
        }
      />

      {/* Default + 404 */}
      <Route index element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
